import Cookies from 'js-cookie';

const tokenKey = "GCAadminmakeittechnology";

export function getTokenByName(name){
	var tokenName = tokenKey+'-'+name;
	return Cookies.get(tokenName);
}

export function setTokenByName(name, token, expired){
	var tokenName = tokenKey+'-'+name;
	return Cookies.set(tokenName, token, {expires: expired});
}

export function removeTokenByName(name){
	var tokenName = tokenKey+'-'+name;
	return Cookies.remove(tokenName);
}